import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const GlobalPatent = () => {
  const faqs = [
    {
      question: "Q: What is Global Patent Feature?",
      answer:
        "A: The Global Patent feature lets users retrieve bibliographic data for patent publications across multiple jurisdictions using data from the European Patent Office (EPO).",
    },
    {
      question: "Q: What input format is supported?",
      answer:
        "A: Enter one publication or patent number per line or separate multiple numbers using commas. Each number must be prefixed with the appropriate country code. For example: US12345678, EP98765432, WO2025123456, JP2024001234.",
    },
    {
      question: "Q: Which jurisdictions are supported?",
      answer:
        "A: The feature supports jurisdictions for which bibliographic data is available through the European Patent Office (EPO). Each publication or patent number must include a valid country code.",
    },
    {
      question: "Q: How many publication or patent numbers can I enter at once?",
      answer:
        "A: You can enter up to 500 publication or patent numbers in a single request.",
    },
    {
      question: "Q: Can I enter publication numbers from different jurisdictions in the same request?",
      answer:
        "A: Yes. You can include publication or patent numbers from multiple jurisdictions in a single request, provided each number is prefixed with the appropriate country code.",
    },
    {
      question: "Q: What happens if I enter an invalid or unsupported patent number?",
      answer:
        'A: JUNE displays an error message in the UI and sends an email notification: "No data found. Check input and try again."',
    },
    {
      question: "Q: How quickly will I get the results?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 publication or patent numbers), processing may take longer, and you will receive an email notification once the file is ready.",
    },
    {
      question: "Q: Can I mix publication numbers and patent numbers in the same request?",
      answer:
        "A: Yes. The Global Patent feature accepts both publication and patent numbers, provided they are prefixed with the appropriate country code and are supported by EPO.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default GlobalPatent;
